import { Theme, createStyles } from '@material-ui/core'

export const foodMenuStyles = (theme: Theme) =>
  createStyles({
    root: {},
    tabPanel: {
      padding: theme.spacing(2, 0),
    },
  })

export const insertMenuStyles = (theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      height: 'auto',
      border: '1px solid',
      borderColor: 'transparent',
    },
  })

export const editMenuStyles = (theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      height: 'auto',
      border: '1px solid',
      borderColor: 'transparent',
    },
  })

export const categoryStyles = (theme: Theme) =>
  createStyles({
    root: {},
    emptyData: {
      marginTop: 60,
    },
    tabPanel: {
      padding: theme.spacing(2, 0),
    },
  })

export const insertCategoryStyles = (theme: Theme) =>
  createStyles({
    root: {},
  })

export const editCategoryStyles = (theme: Theme) =>
  createStyles({
    root: {},
  })
